import React from "react";
import type { TFunction } from "i18next";
import { GetTypographyContent } from "../shared/Typography/Typography";
import brochure from "../../assets/icons/brochure.svg";
import indexCard from "../../assets/icons/indexCard.svg";
import {
  ResourcesLanguageContainer,
  ResourcesReportImage,
  ResourceDescriptionContainer,
  ResourcesSingleFrameContainter,
} from "./Resources.styles";
import brochureEn from "../../assets/files/BTO-UNITY-Complete-Brochure-Patient-Web.pdf";
import brochureEs from "../../assets/files/BTO-UNITY-Complete-Brochure-Patient-Web-ES.pdf";
import unityEn from "../../assets/files/BTO-UNITY-Patient-Rack-Card-EN.pdf";
import unityEs from "../../assets/files/BTO-UNITY-Patient-Rack-Card-ES.pdf";
import untiyCompleteEn from "../../assets/files/BTO-UNITY-Complete-Patient-Rack-Card-EN-Web.pdf";
import unityCompleteEs from "../../assets/files/BTO-UNITY-Complete-Patient-Rack-Card-ES-Web.pdf";

export const ResourcesData = (t: TFunction<"translation">): JSX.Element[] => [
  <React.Fragment key="patient-brochure">
    <ResourcesReportImage src={brochure} alt="Brochure" />
    <ResourcesSingleFrameContainter>
      <ResourceDescriptionContainer>
        {GetTypographyContent({
          content: t("resources.patientBrochure"),
          isBold: true,
          size: "large",
          textColor: "greyMedium",
        })}
        {GetTypographyContent({
          content: "(PDF)",
          size: "small",
          textColor: "greyMedium",
          padding: "4px 0 0 0",
        })}
      </ResourceDescriptionContainer>
      <ResourcesLanguageContainer>
        {GetTypographyContent({
          content: t("resources.languages.english"),
          size: "large",
          textColor: "redMedium",
          link: brochureEn,
          linkInNewWindow: true,
          isDownload: true,
        })}
        <div>&#124;</div>
        {GetTypographyContent({
          content: t("resources.languages.spanish"),
          size: "large",
          textColor: "redMedium",
          link: brochureEs,
          linkInNewWindow: true,
          isDownload: true,
        })}
      </ResourcesLanguageContainer>
    </ResourcesSingleFrameContainter>
  </React.Fragment>,
  <React.Fragment key="index-card">
    <ResourcesReportImage src={indexCard} alt="Index Card" />
    <ResourcesSingleFrameContainter>
      <ResourceDescriptionContainer>
        {GetTypographyContent({
          content: t("resources.unityIndexCard"),
          isBold: true,
          size: "large",
          textColor: "greyMedium",
        })}
        {GetTypographyContent({
          content: "(PDF)",
          size: "small",
          textColor: "greyMedium",
          padding: "4px 0 0 0",
        })}
      </ResourceDescriptionContainer>
      <ResourcesLanguageContainer>
        {GetTypographyContent({
          content: t("resources.languages.english"),
          size: "large",
          textColor: "redMedium",
          link: unityEn,
          linkInNewWindow: true,
          isDownload: true,
        })}
        <div>&#124;</div>
        {GetTypographyContent({
          content: t("resources.languages.spanish"),
          size: "large",
          textColor: "redMedium",
          link: unityEs,
          linkInNewWindow: true,
          isDownload: true,
        })}
      </ResourcesLanguageContainer>
    </ResourcesSingleFrameContainter>
  </React.Fragment>,
  <React.Fragment key="complete-index">
    <ResourcesReportImage src={indexCard} alt="Index Card" />
    <ResourcesSingleFrameContainter>
      <ResourceDescriptionContainer>
        {GetTypographyContent({
          content: t("resources.unityCompleteIndexCard"),
          isBold: true,
          size: "large",
          textColor: "greyMedium",
        })}
        {GetTypographyContent({
          content: "(PDF)",
          size: "small",
          textColor: "greyMedium",
          padding: "4px 0 0 0",
        })}
      </ResourceDescriptionContainer>
      <ResourcesLanguageContainer>
        {GetTypographyContent({
          content: t("resources.languages.english"),
          size: "large",
          textColor: "redMedium",
          link: untiyCompleteEn,
          linkInNewWindow: true,
          isDownload: true,
        })}
        <div>&#124;</div>
        {GetTypographyContent({
          content: t("resources.languages.spanish"),
          size: "large",
          textColor: "redMedium",
          link: unityCompleteEs,
          linkInNewWindow: true,
          isDownload: true,
        })}
      </ResourcesLanguageContainer>
    </ResourcesSingleFrameContainter>
  </React.Fragment>,
];
